import WebsiteModal from "modal/WebsiteModal";

export default class CareersInfoModal extends WebsiteModal {
    constructor(data) {
        super();
        this.data = data;
    }

    buildElement() {
        this.$modal = (
            eotwJSXFactory('div', {className: "modal"}, [
                eotwJSXFactory('div', {className: "modal__bg js-modal-close"}),
                eotwJSXFactory('div', {className: "modal__container"}, [
                    eotwJSXFactory('button', {className: "modal__close js-modal-close"}),
                    eotwJSXFactory('div', {className: "modal__images"}, [
                        eotwJSXFactory('div', {className: "modal__main-image", unsafeHtml: this.data.image}),
                        eotwJSXFactory('div', {className: "modal__red-image", unsafeHtml: this.data.image})
                    ]),
                    eotwJSXFactory('div', {className: "modal__content content-section"}, [
                        eotwJSXFactory('h2', {className: "heading heading--2 heading--underline"}, [this.data.title]),
                        eotwJSXFactory('div', {unsafeHtml: this.data.content})
                    ])
                ])
            ])
        );
    }

    show() {
        super.show();
    }
}


